import React, {Fragment} from "react";
import ChatsContent from "./ChatsContent";
import {Dropdown} from "react-bootstrap";
import avatar from "../../../assets/img/demo/player-avatar-1.png";
import SVG from "react-inlinesvg";
import participant from "../../../assets/svg/actions/icn-add-participant-24px-24px-blue.svg";
import ChatGroupBlankParticipants from "./ChatGroupBlankParticipants";
import ChatBlankComment from "./ChatBlankComment";

class ChatsGroupContent extends ChatsContent {

    onAddParticipantsClick = (event) => {
        event.preventDefault();
        if(this.props.onAddParticipantsClick)
            this.props.onAddParticipantsClick(event);
    }

    blankArea = () => {
        return this.props.data.participants.length == 1 ? (
            <ChatGroupBlankParticipants onAddParticipantsClick={this.onAddParticipantsClick}/>
        ) : (
            <ChatBlankComment/>
        )
    }

    chatDropdownMenuContent = () => {
        return (
            <Fragment>
                <Dropdown.Item>Clear Chats</Dropdown.Item>
                <Dropdown.Item>Delete Group</Dropdown.Item>
            </Fragment>
        )
    }

    getAvatars = () => {
        return (
            this.props.data.participants.map((item) => {
                return (
                    <img src={item.avatar} alt={item.name}/>
                )
            })
        )
    }

    showGroupInfoModal = (event) => {
        event.preventDefault();
        if(this.props.showGroupInfoModal)
            this.props.showGroupInfoModal(event);
    }

    getMemberInfo = () => {
        return (
            <Fragment>
                <div className="group-image">
                    {this.getAvatars()}
                </div>
                <div className="d-flex flex-column">
                    <h3>{this.props.data.name}</h3>
                    <div className="d-flex flex-wrap">
                        <p>{this.props.data.info}</p>
                        <a href="#" onClick={this.showGroupInfoModal}>See Group Info</a>
                    </div>
                </div>
            </Fragment>
        )
    };

    addExtraActions = () => {
        return (
            <a href="#" className="mr-4" onClick={this.onAddParticipantsClick}><i><SVG src={participant}/></i></a>
        );
    }
};

export default ChatsGroupContent;
